import { FC, useState } from 'react';
import { DropdownMenu } from '@cld/dropdown-menu';
import { PrimaryMenuItem } from '../../components/PrimaryMenu/PrimaryMenuItem';
import { PrimaryMenuItemDropdownMenuProps } from './PrimaryMenuItemDropdownMenu.types';

export const PrimaryMenuItemDropdownMenu: FC<PrimaryMenuItemDropdownMenuProps> = ({
  tooltipTitle,
  analyticsMessage,
  children,
  dataTestSpecifier,
  size,
  onOpenedChange,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    onOpenedChange?.(open);
  };

  return (
    <DropdownMenu isOpened={isOpen} placement="leftBottom" onOpenedChange={handleOpenChange} {...rest} data-test-specifier={dataTestSpecifier}>
      <PrimaryMenuItem
        data-test-specifier={dataTestSpecifier && `${dataTestSpecifier}-trigger`}
        analyticsMessage={analyticsMessage}
        tooltipTitle={tooltipTitle}
        selected={isOpen}
        size={size}
      >
        {children}
      </PrimaryMenuItem>
    </DropdownMenu>
  );
};
